import { ButtonTriggerEvent } from '../../../common/components';
import { HubPlace } from '../../../models/hub/hub.place';

export class EditPlaceModalActions {
    confirm: (event: ButtonTriggerEvent, image: HubPlace) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.modal/edit.place.modal.provider.ts